import {isRTL} from '../../../../../../Localization';

export const getValidNewWidth = (width: number, minWidth: number, maxWidth: number) => {
    if (width > maxWidth) {
        return maxWidth;
    } else if (width < minWidth) {
        return minWidth;
    }
    return width;
};

export const getValidOffset = (
    offset: number,
    width: number,
    minWidth: number,
    maxWidth: number
) => {
    const rtl = isRTL();
    const minLeftOffset = rtl ? width - maxWidth : minWidth - width;
    const maxRightOffset = rtl ? width - minWidth : maxWidth - width;

    if (offset > maxRightOffset) {
        return maxRightOffset;
    } else if (offset < minLeftOffset) {
        return minLeftOffset;
    }

    return offset;
};
